// extracted by mini-css-extract-plugin
export var layoutContainer = "_dn-0";
export var layoutContainerNoRounding = "_dn-6";
export var layoutContainerOpen = "_dn-5";
export var layoutContainerResizing = "_dn-1";
export var mainContent = "_dn-2";
export var resizeDivider = "_dn-3";
export var slidePanel = "_dn-4";